import styled from 'styled-components';

export const UserItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    padding: 5px 10px;
`;


export const UserItemText = styled.span`
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
  line-height: 18px;
`;